import { apiClient } from "../../../config/axios.config";
import type { Response } from "../../../types/api.types";
import type { AuthSignUpByLoginIdForm, AuthSignUpForm } from "../dtos/request/auth.request";
import type { Auth, LoginResponse } from "../dtos/response/auth.response";

export interface AuthLogin {
  email: string;
  password: string;
}

export interface LoginAuthForm {
  loginId: string;
  password: string;
}
export interface ChangePassword {
  originalPassword: string;
  newPassword: string;
}

const model = "/v1/auth";

export const authLogin = async (auth: AuthLogin): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/login`, auth);
  return data;
};

export const loginByloginId = async (auth: LoginAuthForm): Promise<Response<LoginResponse>> => {
  const { data } = await apiClient.post(`${model}/loginByLoginId`, auth);
  return data;
};

export const changePassword = async (form: ChangePassword): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/changePassword`, form);
  return data;
};

export const authLogout = async (): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/logout`);
  return data;
};

export const getAuthInfo = async (): Promise<Response<Auth>> => {
  const { data } = await apiClient.get(`${model}/myInfo`);
  return data;
};

export const authTokenRefresh = async (token: string): Promise<Response<LoginResponse>> => {
  const { data } = await apiClient.post(
    `${model}/getAccessToken`,
    {},
    {
      headers: {
        refreshToken: token,
      },
    }
  );
  return data;
};

export const authSignUp = async (form: AuthSignUpForm): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/signup`, form);
  return data;
};

export const authSignUpByLoginId = async (form: AuthSignUpByLoginIdForm) => {
  const { data } = await apiClient.post(`${model}/signupByLoginId`, form);
  return data;
}

export const postEmail = async (form: {
  receiver: string;
  subject: string;
  body: string;
}) => {
  const { data } = await apiClient.post("v1/email/inquiry", form.body, { params: form });
  return data;
};
